/**
 * KAN-871: личный Telegram-аккаунт менеджера (подключает сам менеджер в приложении).
 *
 *   GET    /api/v1/me/personal-telegram/                - {account | null}
 *   POST   /api/v1/me/personal-telegram/login/start/    - {phone} -> {login_id, expires_in, sent_via}
 *   POST   /api/v1/me/personal-telegram/login/confirm/  - {login_id, code, password?} -> {account} | {needs_password}
 *   DELETE /api/v1/me/personal-telegram/                - отключить
 */
import apiClient from './client';

/** Личный аккаунт в /auth/me (personal_telegram_account). */
export interface PersonalTelegramBrief {
  account_id: string;
  label: string;
  username: string;
  status: string;
}

/** Личный аккаунт в ответе GET и подтверждения входа. */
export interface PersonalTelegramAccount extends PersonalTelegramBrief {
  phone: string;
}

export interface PersonalTelegramState {
  account: PersonalTelegramAccount | null;
}

export interface PersonalLoginStartResult {
  login_id: string;
  expires_in?: number;
  sent_via?: string;
}

export interface PersonalLoginConfirmBody {
  login_id: string;
  code: string;
  password?: string;
}

export type PersonalLoginConfirmResult =
  | { account: PersonalTelegramAccount; needs_password?: false }
  | { needs_password: true; account?: undefined };

const BASE_URL = '/api/v1/me/personal-telegram/';

export const personalTelegramApi = {
  async get(): Promise<PersonalTelegramState> {
    const res = await apiClient.get<PersonalTelegramState>(BASE_URL);
    return res.data;
  },

  async loginStart(phone: string): Promise<PersonalLoginStartResult> {
    const res = await apiClient.post<PersonalLoginStartResult>(`${BASE_URL}login/start/`, { phone });
    return res.data;
  },

  async loginConfirm({ login_id, code, password }: PersonalLoginConfirmBody): Promise<PersonalLoginConfirmResult> {
    const body: PersonalLoginConfirmBody = { login_id, code };
    if (password) body.password = password;
    const res = await apiClient.post<PersonalLoginConfirmResult>(`${BASE_URL}login/confirm/`, body);
    return res.data;
  },

  async disconnect(): Promise<void> {
    await apiClient.delete(BASE_URL);
  },
};
